module.exports = __webpack_public_path__ + "img/symbol_1.8219a2e4.png";